import 'intl-tel-input';
import multiStepForm from './multi-step-form';
import initializeFollowingPlaceholder from './placeholder';

const initialize = (inboxSocial) => {
    initializeFollowingPlaceholder();

    // Display first tab
    multiStepForm.switchToTab(window.current_tab ? current_tab : 'signup_personal_start');


    $('body').on('input', '#username', () => {
        document.getElementById('username').value = document.getElementById('username').value.toLowerCase();
    });

    // Init telephone input
    const phoneInput = $('#phone');
    phoneInput.intlTelInput({
        preferredCountries: phoneInput.data('preferred-countries'),
        separateDialCode: true,
        initialCountry: phoneInput.data('initial-country')
    });

    const countryCodeInput = $('#country-code');
    if (countryCodeInput.length) {
        phoneInput.on('countrychange', (e, countryData) => {
            countryCodeInput.val(countryData.iso2);
        });
    }

    const phoneCodeInput = $('#phone-code');
    if (phoneCodeInput.length) {
        phoneInput.on('countrychange', (e, countryData) => {
           phoneCodeInput.val('+' + countryData.dialCode);
        });
    }
}

export default initialize;
